import isObject from 'lodash-es/isObject';

import { create, v, w } from '@dojo/framework/core/vdom';
import { theme } from '@dojo/widgets/middleware/theme';

// make generated .d.ts file valid
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { WNodeFactory, WidgetProperties, DNode } from '@dojo/framework/core/interfaces';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { ThemeProperties } from '@dojo/framework/core/middleware/theme';

import { TopicElement, TopicAttrs, TopicDef } from 'lcc-state/interfaces';
import { Title } from './title';
import { GenerateItem, ItemType } from './generate-item';

export interface ExtendedCSS {
	[name: string]: string[];
}

export interface GeneratorProperties {
	topic: {
		attributes: TopicAttrs;
		children: TopicElement[];
	};
	widgetType?: string | null;
	skipTitle: boolean;
	renderBody?: boolean;
	insection?: boolean;
	intable?: boolean;
	compconn?: boolean;
	additionalClasses?: ExtendedCSS;
}

const factory = create({ theme }).properties<GeneratorProperties>();

export const Generator = factory(({ properties }) => {
	const {
		key: basekey,
		widgetType = null,
		skipTitle,
		insection = false,
		intable = false,
		renderBody = false,
		compconn,
		additionalClasses
	} = properties();
	let { topic } = properties();
	if ((topic as any).topic) {
		topic = (topic as any).topic;
	}
	const attributes = topic.attributes;
	const children = topic.children;
	const kids: DNode[] = [];
	if (!children) {
		if (insection || intable) {
			return kids;
		}
		const xqa = basekey && `generator ${basekey}`;
		return v('div', { key: basekey, xqa }, kids);
	}

	const shortdescIndex = children.findIndex((value) => {
		return isObject(value) && 'shortdesc' in value;
	});
	if (!skipTitle && !insection) {
		kids.push(w(Title, { title: children[0] as TopicDef, widgetType, insection }));
	}
	if (!renderBody && shortdescIndex >= 0) {
		const item: ItemType = children[shortdescIndex] as ItemType;
		kids.push(w(GenerateItem, { item, compconn, additionalClasses }));
	} else {
		const bodyAt = children.findIndex((value) => {
			return isObject(value) && 'body' in value;
		});
		if (bodyAt > -1) {
			const bodykids = (children[bodyAt].body as TopicElement).children as {
				[key: string]: TopicElement | string;
			}[];
			bodykids.forEach((val) => {
				kids.push(w(GenerateItem, { item: val, compconn, additionalClasses }));
			});
		} else if (insection) {
			const sectionkids = children as {
				[key: string]: TopicElement | string;
			}[];
			sectionkids.forEach((val) => {
				kids.push(w(GenerateItem, { item: val, compconn, additionalClasses }));
			});
		} else if (intable) {
			const tablekids = children as {
				[key: string]: TopicElement | string;
			}[];
			tablekids.forEach((val) => {
				kids.push(w(GenerateItem, { item: val, compconn, additionalClasses }));
			});
		} else {
			const idx = Math.min(children.length - 1, 1);
			kids.push(w(GenerateItem, { item: children[idx] as ItemType, compconn, additionalClasses }));
		}
	}
	const { id: idval } = attributes || {};
	if (insection || intable) {
		return kids;
	}
	const key = basekey || idval;
	const xqa = key && `generator ${key}`;
	return v('div', { key, xqa }, kids);
});
